module.exports = __webpack_public_path__ + "img/action-5.9624cd87.svg";